module.exports = __webpack_public_path__ + "img/pic.00c9886e.png";